import { pipe } from "fp-ts/lib/pipeable";
import { array } from "fp-ts";

export const mergeOnTop = <T extends unknown>(mergeBase: Array<T>) =>
    (mergingArray: Array<T>): Array<T> =>
        pipe(
            mergeBase,
            array.mapWithIndex((index, value) =>
                mergingArray[index] ?
                    mergingArray[index] :
                    value
            )
        )
;